import { GridRowModel } from '@mui/x-data-grid';
import { AclEntriesCommonTooltip } from 'common/components/sharedCustomComponents/AclEntriesCommonTooltip/AclEntriesCommonTooltip';
import {
    ActionDefinition,
    ColumnDefinition,
    ColumnType,
    Operations
} from 'common/types/TypeDefs';

const ACTIONS_COLUMN: ColumnDefinition = {
    columnId: 'actions',
    columnName: 'Action',
    columnType: ColumnType.Action,
    size: 0.5
};

const DEFAULT_USERGROUP_ACL_ENTRIES_COLUMNS: ColumnDefinition[] = [
    { columnId: 'resourceTableName', columnName: 'ACL Resource', columnType: ColumnType.First },
    { columnId: 'conditionsToDisplay', columnName: 'ACL Condition', columnType: ColumnType.Tooltip },
    { columnId: 'accessTableName', columnName: 'ACL Access', columnType: ColumnType.Tooltip }
];

const USERGROUP_ACL_ENTRIES_WITH_LICENSE_INFO: ColumnDefinition[] = [
    ...DEFAULT_USERGROUP_ACL_ENTRIES_COLUMNS,
    { columnId: 'licenseBillingRecord', columnName: 'License', columnType: ColumnType.Tooltip },
    { columnId: 'startDate', columnName: 'ACL Start Date', columnType: ColumnType.DatetimeTooltip, size: 0.9 },
    { columnId: 'endDate', columnName: 'ACL End Date', columnType: ColumnType.DatetimeTooltip, size: 0.9 },
    {
        columnId: 'status',
        columnName: 'ACL Status',
        columnType: ColumnType.Chip,
        copy: false,
        sortable: false,
        size: 99,
        toolTip: AclEntriesCommonTooltip
    }
];

export const _createUserGroupAclEntriesDataGridColumns = (
    isLicenseRequired?: boolean
): ColumnDefinition[] => isLicenseRequired ?
    [...USERGROUP_ACL_ENTRIES_WITH_LICENSE_INFO, ACTIONS_COLUMN] :
    [...DEFAULT_USERGROUP_ACL_ENTRIES_COLUMNS, ACTIONS_COLUMN];

export const _createUserGroupAclEntriesActionDefinitions = (
    shouldDisableButtons: boolean,
    disableEditActionCallback: (row: GridRowModel) => boolean,
): ActionDefinition[] => {
    return  [
        { action: Operations.Delete, disabled: shouldDisableButtons },
        { action: Operations.Edit, disabled: disableEditActionCallback }
    ];
};
